import {
  Component,
  Input,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
  Output, EventEmitter,
  ViewChild
} from '@angular/core';
import { AnticipatedExpendituresComponent, FinancialHealthReport } from '../../../reports/shared/models';
import { FiscalYear } from 'app/internal/shared/models';
import { Plan } from 'app/internal/plans/shared/models';
import { DxPopoverComponent } from 'devextreme-angular/ui/popover';

@Component({
  selector: 'sp-dashboard-future-display',
  templateUrl: './dashboard-future-display.component.html',
  styleUrls: ['./dashboard-future-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardFutureDisplayComponent implements OnChanges {
  @Input() fiscalYear: FiscalYear;
  @Input() reportData: FinancialHealthReport;
  @Input() plans: Plan[];
  @Input() disclosurePlanId: string;
  @Output() backToDashboard: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('contributionsPopover', { static: false }) contributionsPopover: DxPopoverComponent;

  collectionFrequency = '';
  hasAdoptedPlan = false;
  futurePlan: Plan = null;

  selectedAnticipatedExpenditures: AnticipatedExpendituresComponent[];
  selectedExpenditureYear: string;
  totalCurrentReplacementCost: number;
  totalAnticipatedExpenditures: number;
  contributionsPopoverTarget: any;

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['plans'] && this.plans) {
      const recommendedPlan = this.plans.find(p => p.isRecommended === true && p.isDefaultRecommendedPlan !== true);
      const adoptedPlan = this.plans.find(p => p.isAdopted === true);
      const disclosurePlan = this.plans.find(p => p.planId === this.disclosurePlanId);

      this.hasAdoptedPlan = adoptedPlan != null || disclosurePlan != null;
      this.futurePlan = adoptedPlan ? adoptedPlan : disclosurePlan ? disclosurePlan : recommendedPlan;
    }

    if (changes['disclosurePlanId']) {
      if (this.disclosurePlanId && !this.hasAdoptedPlan) {
        this.hasAdoptedPlan = true;
        this.futurePlan = this.plans.find(p => p.planId === this.disclosurePlanId);
      }
    }

    if (changes['reportData'] && this.reportData) {
      this.collectionFrequency =
        this.reportData.fundingReport == null || this.reportData.fundingReport.fundingCollectionFrequency == null
          ? ''
          : this.reportData.fundingReport.fundingCollectionFrequency.name;
    }
  }

  getContributionsToReserves() {
    if (this.futurePlan && this.futurePlan.fundingReport && this.futurePlan.fundingReport.years) {
      return this.futurePlan.fundingReport.years[0].annualReserveContributions;
    }
    return this.reportData.contributionsToReserves;
  }

  selectExpenditureYear(year: string) {
    if (year) {
      this.showAnticipatedExpenditures(year);
      this.scrollTo('anticipated-expenditures');
    }
  }

   
  displayYearsDropdownChanged() {
    // This is odd, but this was basically needed to force the Funding Chart to refresh.  
  }

  setBackTo() {
    this.backToDashboard.emit();
  }

  private scrollTo(fragment: string) {
    const element = document.getElementById(fragment);
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    element.scrollTop -= 80;
  }

  private showAnticipatedExpenditures(year: string) {
    const anticipatedExpenditures =
      this.reportData.anticipatedExpendituresReport.anticipatedExpenditureYears.find(x => x.name.startsWith(year));

    this.selectedExpenditureYear = anticipatedExpenditures.name;
    this.selectedAnticipatedExpenditures = [];
    anticipatedExpenditures.propertyComponents
      .forEach(y => this.selectedAnticipatedExpenditures.push(y));

    this.totalCurrentReplacementCost = this.selectedAnticipatedExpenditures.reduce((a, b) => a + b.currentReplacementCost, 0);
    this.totalAnticipatedExpenditures = this.selectedAnticipatedExpenditures.reduce((a, b) => a + b.anticipatedExpenditures, 0);
  }

  showContributionsPopover(event: MouseEvent) {
    if (!this.contributionsPopover || !this.contributionsPopover.instance) {
      return;
    }
    this.contributionsPopoverTarget = event.currentTarget;
    this.contributionsPopover.instance.show();
  }

  hideContributionsPopover() {
    if (!this.contributionsPopover || !this.contributionsPopover.instance) {
      return;
    }
    this.contributionsPopover.instance.hide();
  }

  onContributionsPopoverHiding(e: any) {
    const isMouseInsidePopover = e.component.content().parentNode.matches(':hover');
    e.cancel = isMouseInsidePopover;
  }

  onContributionsPopoverContentReady(e: any) {
    (e.component.content() as HTMLElement).onmouseleave = function () {
      e.component.hide();
    };
  }
}
